import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

interface CheckoutErrorBannerProps {
  onOpenIntakeForm: () => void;
  rounded?: boolean;
}

export const CheckoutErrorBanner: React.FC<CheckoutErrorBannerProps> = ({
  onOpenIntakeForm,
  rounded = false,
}): JSX.Element => {
  return (
    <Alert variant="checkoutError" sx={rounded ? { borderRadius: '10px' } : undefined}>
      <Typography component="p" variant="heading.subsection" className="CheckoutErrorBanner-title">
        Could not Checkout Order
      </Typography>
      <Typography component="p" variant="body.md" className="CheckoutErrorBanner-body">
        Something went wrong when checking out your order. Please try again in a moment. If the issue continues, you can
        submit your information using our lead form and a representative will help complete your order.{' '}
        <Link variant="inlineError" onClick={onOpenIntakeForm}>
          Click here to submit a lead form.
        </Link>
      </Typography>
    </Alert>
  );
};
